import { createSlice } from "@reduxjs/toolkit";
import OrganizationRepository from "../repositories/OrganizationRepository";

const userSlice = createSlice({
    name: "userDetails",
    initialState: {
        policies: [],
        organizations: [],
        parentOrganizations: [],
        reportEnabledOrganizations: [],
        enabledOrganizationsDisabilitySnapshot: [],
        enabledOrganizationsTrendsBenchmarking: [],
        loaded: false,
        isLoading: false,
        error: null,
    },
    reducers: {
        setUserDetails(state, action) {
            state.policies = action.payload.policies;
            state.organizations = action.payload.organizations;
            state.parentOrganizations =
                OrganizationRepository.getParentOrganizations(
                    action.payload.organizations
                );
            state.loaded = true;

        },
        setUserDetailsLoadingStatus(state, action) {
            state.isLoading = action.payload.isLoading;
            state.error = action.payload.error;
        },
        setReportEnabledOrgs(state, action) {
            state.reportEnabledOrganizations = action.payload.reportEnabledOrganizations;
            state.enabledOrganizationsDisabilitySnapshot =
                action.payload.enabledOrganizationsDisabilitySnapshot ?? [];
            state.enabledOrganizationsTrendsBenchmarking =
                action.payload.enabledOrganizationsTrendsBenchmarking ?? [];
        }
    },
});

export const { setUserDetails, setUserDetailsLoadingStatus, setReportEnabledOrganizations, setReportEnabledOrgs } =
    userSlice.actions;

export default userSlice.reducer;
